__turbopack_context__.v({
  "ctaSection": "ReviewHero-module__zPWpsa__ctaSection",
  "fixedCta": "ReviewHero-module__zPWpsa__fixedCta",
  "fullWwrapper": "ReviewHero-module__zPWpsa__fullWwrapper",
  "hidden": "ReviewHero-module__zPWpsa__hidden",
  "infoSection": "ReviewHero-module__zPWpsa__infoSection",
  "keyInfo": "ReviewHero-module__zPWpsa__keyInfo",
  "keyInfoItem": "ReviewHero-module__zPWpsa__keyInfoItem",
  "ratingSection": "ReviewHero-module__zPWpsa__ratingSection",
  "vehicleSection": "ReviewHero-module__zPWpsa__vehicleSection",
  "visible": "ReviewHero-module__zPWpsa__visible",
  "wrapper": "ReviewHero-module__zPWpsa__wrapper",
});
